<template>
</template>

<script>

import {LeadBus} from '../router/index';
import IdentifierUtils from '../javascript-classes/utils/identifier.js';

export default {
    props: {
        service: {},
        activePres: {},
        user: {}
    },

    mounted() {
        LeadBus.$on('recordLead', (leadData) => {
            if (!this.activePres || !this.activePres.props) {
                return;
            }

            let presenter = '';

            if (this.activePres.props.PresenterInfo) {
                presenter = this.activePres.props.PresenterInfo.displayName;
            } else if (this.activePres.props.PresenterProfiles && this.activePres.props.PresenterProfiles.profiles
                && this.activePres.props.PresenterProfiles.profiles.length > 0
                && this.activePres.props.PresenterProfiles.profiles[0]) {
                presenter = this.activePres.props.PresenterProfiles.profiles[0].displayName;
            } else {
                return;
            }

            this.service.postLead(JSON.stringify({
                data: JSON.stringify(leadData.data),
                leadId: IdentifierUtils.guid(),
                presenter: presenter,
                sessionId: this.activePres.id,  
                timestamp: Date.now().toString(),
                type: leadData.type,
                userId: this.user.id
            }));
        });
    }
};

</script>



// WEBPACK FOOTER //
// LeadGen.vue?52e99e57